<template>

  <div class="search">
    <h4>Search by keywords</h4>
    <div class="search-input">
      <input class="search-input--box" v-model="search" placeholder="" v-on:keyup.enter="loadResults">
      <button @click="loadResults" class="search-input--submit">Go</button>
    </div>
    
    <div class="search-manufacturers">
      <h4>Search by manufacturer</h4>
      
      <select v-model="clickSearch" v-on:change="onClickResults(clickSearch)">
        <option disabled value="">Please select one</option>
        <option v-for="item in manufacturers"  v-bind:value="item">{{ item }}</option>
        
      </select>
      <h2 v-if="loading">Searching...</h2>
      <h2 v-if="results === 'empty'">No results to show</h2>
      <h2 v-if="results && results !== 'empty'">{{ results.length }} Results:</h2>
    </div>
    <div class="search-results">
      <div class="search-results-result" v-for="result in results">
        <lightbox v-if="result.img && !result.model" :key="result.img" v-bind:src="api + result.img">
          <img width="300px" v-bind:src="api + result.img">
        </lightbox>
        <lightbox class="search-results-result--model" v-if="result.model" :key="result.model" v-bind:src="api + result.model">
          <img v-if="result.model" width="300px" v-bind:src="api + result.model">
        </lightbox>
        <h3 class="search-results-result--title"> {{ result.title }} </h3>
        <h4 class="search-results-result--desc"> {{ result.desc }} </h4>
      </div>
    </div>
  </div>



</template>

<script>
import axios from 'axios'
import VueAxios from 'vue-axios'

export default {
  name: 'Search',
  data: function () {
    return {
      search: '',
      clickSearch: '',
      loading: false,
      manufacturers: ['Ace Jewellery', 'ACME', 'Airfix', 'Amico', 'AMR', 'AMT', 'Anguplas', 'Aoshin', 'Arora', 'Atlantis', 'Atlas Edition', 'Aurora', 'Auto-maniac', 'Auto-rama', 'AutoArt', 'Autosculpt', 'Avon', 'Babbacombe', 'Bandi Line B.O.S.', 'Bburago', 'Best', 'Bestbox', 'Bondai', 'Box', 'Brohm', 'Busch', 'C-Scale', 'Carlton Ware', 'Carrera', 'Cartronic', 'Casa Grande', 'Century Dragon', 'Chevron', 'Chymos', 'Circuit 24', 'CJM', 'Classique', 'Clifford', 'Clivedon', 'Clover Toys', 'CN', 'Colliery Road', 'Collumbus', 'Colne Valley Workshop (CVW)', 'Comoy´s', 'Compulsion Gallery', 'Contact', 'Coopercraft', 'Corgi', 'Corgi Juniors', 'Corgi Toys', 'Country Artists Ltd', 'Cragstan', 'Crio', 'Crystal Clear Collectables', 'Cult', 'Danbury Mint', 'Dartmouth Pottery', 'Daum', 'DeAgostini', 'DelPrado', 'Deluxe Racer', 'Devon Ceramics', 'Diener', 'Dinkum Classics', 'Dinky', 'Dinky Toys', 'Disney by Mattel', 'Dogmoch', 'E&J Mining', 'Edge', 'Edison Giacattoli', 'Efsi', 'Eidai Trip', 'Eko', 'Elektroplast', 'Eligor', 'Ertl', 'Euromodel (I.M.U.)', 'Faller', 'Ferrero', 'Fleetline', 'Franklin Mint', 'Frog', 'Fun-Ho!', 'Galoob', 'GD-cartuning', 'Gems&Cobwebs', 'Grand Prix Models', 'Grell', 'GT', 'Gunze Sangyo', 'Ha/ma', 'Hamburgmodell', 'Hatsune', 'Heller', 'Hermanos Herjera', 'Herpa', 'High Speed', 'Hofbauer', 'Hornby', 'Hot-wheels', 'HT', 'Hugo Boss', 'Huki', 'Husky', 'I.M.U.', 'Ideal', 'Il Bialbero', 'Imai', 'Irwin', 'IXO', 'Jean', 'Jim´s Custom Rod Shop', 'Jimson', 'JK', 'Joal', 'Johanna', 'John Day', 'Johnny Lightning', 'Johnny Toymaker', 'John Putnam', 'Jonathan Adler', 'Jouef', 'K. K. Sakura', 'Kaden', 'Kenmore', 'Kerico', 'Kim', 'Kirk', 'Korris Kars', 'Krazee Wheels', 'Kyosho', 'LB', 'LEGO', 'Le Gogh (Eric Hunter)', 'Lemezáru Gyár', 'Lenox', 'Leonardo', 'Lesney', 'Lesse & Pavey', 'Lincoln International', 'Lindberg', 'Lionel', 'Lledo (Vanguards)', 'Lone Star', 'Lucky Toys', 'Luxe Car', 'M.C. Toy (Maisto)', 'Mahafaly', 'Maisto', 'Majorette', 'Malibu Collection', 'Maquette', 'Marklin', 'Mark Models', 'Marque Models', 'Marx', 'Master-Craft', 'Masudaya MT', 'Matchbox by Mattel', 'Matrix', 'McGregor', 'Mega', 'Melho', 'Michel Aroutcheff', 'Midgetoy', 'Mikes Motors', 'Milestone (Gems&Cobwebs)', 'Mini-Marque', 'Minialuxe', 'Miniature Car', 'Minic', 'Modern Toy', 'Monogram', 'Mont-Blanc', 'Motoring Sculpture', 'Motormax', 'Moustiers "Four"', 'MRF', 'NAC', 'Namura Toys', 'Ncky Toys', 'New-Ray', 'New Britght', 'Nic Duysens', 'Ninco', 'Norev', 'OCA', 'Ocuk', 'Odgi', 'Ok', 'Oxford', 'Palmer', 'Paragon', 'Parijouet', 'Pines', 'PIT', 'Play Art', 'Playcraft', 'Polistil', 'Politoys', 'Premium X', 'Princess House', 'Provence Moulage', 'QD', 'R&B Inc.', 'R&L', 'Radar', 'RAE/Bellini', 'Raleigh', 'RC', 'Renam', 'Replica Dream', 'Rever', 'Ricko', 'Roadrace', 'Road Signature (Yatming)', 'Road Tough (Yatming)', 'Royal Hampshire', 'RPM', 'Saico', 'Sakthi Portugal', 'Sakura', 'Sander', 'Scalecraft', 'Scalextrix', 'Schordele', 'Schuco', 'Scorpio Innovations', 'Seidel', 'Siku', 'Sims Mars', 'Sixties Classics', 'SK', 'Slot Classic', 'Small Wheels', 'SMTS', 'Snields', 'Sohbi', 'Solido', 'Spark', 'Spot-On', 'SPS', 'SSS Toys', 'Stelco', 'Sterling', 'Straco (Yatming)', 'Strombecker', 'Summer', 'Swank', 'Syot', 'T.T.', 'Talseya', 'Tecnomodel', 'Tekno', 'Tenariv', 'The Leonel Corp', 'Tomte Laerdal', 'Tootsie Toy', 'Top Slot', 'TPS', 'Traffic Jam', 'Une Ligne', 'Universal Hobbies', 'UPC', 'Vandor', 'Vanguards (Lledo)', 'Villeroy & Boch', 'Vintage Pottery', 'Vroom', 'White Box', 'White Point', 'Wiking', 'XIK', 'Yanoman', 'Yatming', 'YL', 'Yonezawa', 'Zebra Yoys', 'Zee', 'Zip', 'Zylmex', 'Zzzip Wheel'],
      results: null,
      api: ''
    }
  },
  methods: {
    loadResults: function () {
      this.results = null
      this.loading = true
      var app = this
      axios.get(app.api + '/admin/api/slides/' + app.search).then(function (response) {
        if (response.data.length === 0) {
          app.results = 'empty'
        } else {
          app.results = response.data
        }
        app.loading = false
      })
    },
    onClickResults: function (item) {
      this.search = item
      this.loadResults()
    }
  },
  mounted () {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

$bar-grey: rgba(48, 48, 42, 1);

.search {
    text-align: center;
    min-height: calc(100vh - 120px);
    padding-top: 20px;    

    h4 {
      margin: 0;
    }

  &-input {
    margin: 25px auto;
    display: flex;
    width: 300px;
    
    &--box {
      width: 200px;
      padding: 10px;
      font-size: 20px;
      height: 40px;
      vertical-align: top;
      border: 1px solid black;
      border-radius: 0px;

       &:focus {
         outline: none;
       }
    }
    &--submit {
      width: 100px;
      height: 40px;
      vertical-align: top;
      background-color: $bar-grey;
      color: white;
      border: 1px solid $bar-grey;
      border-radius: 0px;
      &:hover {
        background-color: white;
        color: black;
      }
       &:focus {
         outline: none;
       }
    }
  }
  
  &-manufacturers {
    max-width: 95%;
    margin: 20px auto;
    text-align: center;
    &::before {
    content: "▼";
    position: absolute;
    margin-top: 50px;
    margin-left: 120px;
    }
    
    h2 {
      margin: 40px 0 20px 0;
      font-size: 18px;
    }
    
    select {
      position: relative;
      z-index: 999;
      margin-top: 20px;
      width: 300px;
      padding: 10px;
      font-size: 20px;
      height: 40px;
      vertical-align: top;
      border: 1px solid black;
      border-radius: 0px;
      background: transparent;
      -webkit-appearance: none;
      font-size: 12px;
      cursor: pointer;
      .select-arrow {
        float: right;
      }
    }
    
    &--item {
      display: inline-flex;
      border: 1px solid $bar-grey;
      padding: 4px;
      margin: 2px;
      font-size: 12px;
      cursor: pointer;
      &:hover {
        border-color: white;
        background-color: $bar-grey;
        color: white;
      }
    }
  }

  &-results {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;

    &--alert {
      width: 100%;
      height: 100px;
      text-align: center;
      h2 {
        font-size: 20px;
      }
    }
    
    &-result {
      margin: 15px;
      text-align: center;
      span {
        display: flex;
        align-items: center;
        height: 169px;
        background: #F0F5F8;
        img {
          cursor: pointer;
        }
      }

      &--title {
        font-size: 18px;
      }
      &--desc {
        font-size: 14px;
      }
    }
  }
}
@media screen and (max-width: 768px) {
  
  .search {
     min-height: calc(100vh - 90px);
  }
}

</style>



// WEBPACK FOOTER //
// Search.vue?76e71847